// extracted by mini-css-extract-plugin
export default {"container":"NoContent_container__15AAx","noCenter":"NoContent_noCenter__P8ymL","button":"NoContent_button__X9svf"};